var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":_vm.id + _vm.value}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.internalSelected),expression:"internalSelected"}],attrs:{"type":"radio","id":_vm.id + _vm.value,"name":_vm.name},domProps:{"value":_vm.value,"checked":_vm._q(_vm.internalSelected,_vm.value)},on:{"change":function($event){_vm.internalSelected=_vm.value}}}),_vm._v("\n\t\t"+_vm._s(_vm.label)+"\n\t")])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./admin/src/js/components/AcRadio.vue?vue&type=template&id=00295daa
// module id = 26
// module chunks = 0